@if (duration()) {
  <span class="content__transport-duration ci-paragraph-p1-regular">
    {{ duration() | duration }}
  </span>
}